import React from "react";
import { Alert } from "reactstrap";
import MainLayout from "../Layout/MainLayout";
import ReviewModal from "../Shared/Modals/ReviewModal";
import { RequestForm } from "./RequestForm";
import FormContainer from "../Shared/FormContainer";
import DisplayState from "../Shared/DisplayState";
import { validateInput } from "./validateInput";
import { ReviewData } from "./ReviewData";
import modalMessages from "./modalMessages";
import { constructSquadMemberList } from "./util";

import { defaultState } from "./defaultState";
// import { devDefaultState as defaultState } from "./defaultState";

export default function SpiritRequest() {
  return (
    <MainLayout
      sidebar={
        <div className="bg-light container pt-3 pb-3">
          <h5>About the Request Process</h5>
          <p>
            If you'd like to have a mascot or members of our cheer and dance
            teams appear at your event, please fill out the request form.
          </p>
          <p>
            Please note that we may not be able to fulfill all requests, and
            submission of this form does not mean your request has been
            approved.
          </p>
        </div>
      }
    >
      <section className="mb-3">
        <h1 className="display-4">Spirit Request</h1>
        <Alert color="info">
          Please fill out a separate request for each event or project
        </Alert>
        <FormContainer
          formatRequest={formatForAPI}
          defaultContainerState={defaultState}
          formType="spirit"
          validateInput={validateInput}
          render={containerState => {
            const {
              hideModal,
              onConfirmSubmit,
              resetFormState
            } = containerState;

            return [
              <p key="0">
                <span className="text-info">*</span> All fields are required
              </p>,
              <RequestForm key="1" {...containerState} />,
              <ReviewModal
                key="2"
                show={containerState.formState.showModal}
                onGoBack={hideModal}
                onConfirmSubmit={onConfirmSubmit}
                userInput={containerState.userInput}
                messages={modalMessages}
                status={containerState.formState.requestStatus}
                ReviewComponent={ReviewData}
                resetForm={resetFormState}
                // {...containerState}
              />,
              <DisplayState key="3" state={containerState.userInput} />,
              <DisplayState key="4" state={containerState.formState} />
            ];
          }}
        />
      </section>
    </MainLayout>
  );
}

// Take user input from form state and flatten it for sending to the server
function formatForAPI(userInput) {
  const keys = Object.keys(userInput);

  let payload = {};

  keys.forEach(key => {
    const value = userInput[key].val;
    if (!value) {
      return null;
    }
    payload[key] = value;
  });

  payload.squadMembersList = constructSquadMemberList(userInput.squadMembers);

  return payload;
}
// SAMPLE PAYLOAD FORMAT
// const json = {
//   organization: "TEST",
//   type: "business",
//   contactName: "DREW",
//   phone: "123456",
//   email: "de@de.com",
//   due: "2018-09-19T16:00:00.715Z",
//   description: "adfads",
//   locationName: "adsfasd",
//   locationAddress: "asdfas",
//   locationCity: "asdf",
//   locationState: "adsfasd",
//   locationZip: "adsfasdfas",
//   squadMembersList: "Smokey (costume), Smokey (live), Davy Crockett"
// };



// WEBPACK FOOTER //
// ./src/Spirit/SpiritRequest.jsx